const noOp = ()=>{};
function smartQueue(handler, opts = {}) {
    let timer;
    let tmp;
    let running;
    const queue = opts.initial || [];
    const max = opts.max || 1 / 0;
    const int = opts.interval || 10e3;
    const onEmpty = opts.onEmpty || noOp;
    const onPause = opts.onPause || noOp;
    function batch(all) {
        clearInterval(timer);
        const removed = queue.splice(0, max);
        if (removed.length) handler(removed, queue);
        if (!queue.length) {
            running = false;
            return onEmpty(queue);
        }
        if (all) return batch();
        return ticker();
    }
    function ticker() {
        running = true;
        timer = setInterval(batch, int);
    }
    if (queue.length) ticker();
    return {
        flush: (all)=>{
            batch(all);
        },
        resume: ()=>{
            batch();
        },
        push: (val)=>{
            tmp = queue.push(val);
            if (tmp >= max && !opts.throttle) batch();
            if (!running) ticker();
            return tmp;
        },
        size: ()=>queue.length,
        pause: (toFlush)=>{
            if (toFlush) batch();
            clearInterval(timer);
            running = false;
            onPause(queue);
        }
    };
}
export { smartQueue };

//# sourceMappingURL=queue.js.map